// Convierte el texto plano del contrato en HTML enriquecido para impresión/PDF.

const SECCIONES = ["REUNIDAS", "EXPONEN", "ESTIPULACIONES"];
const ORDINALES = [
  "PRIMERA", "SEGUNDA", "TERCERA", "CUARTA", "QUINTA", "SEXTA", "SÉPTIMA", "SEPTIMA",
  "OCTAVA", "NOVENA", "DÉCIMA", "DECIMA", "UNDÉCIMA", "UNDECIMA", "DUODÉCIMA", "DUODECIMA",
  "DÉCIMO PRIMERA", "DECIMO PRIMERA", "DÉCIMO SEGUNDA", "DECIMO SEGUNDA",
  "DÉCIMO TERCERA", "DECIMO TERCERA", "DECIMOTERCERA", "DÉCIMO CUARTA", "DECIMO CUARTA",
  "DECIMOCUARTA", "DÉCIMO QUINTA", "DECIMO QUINTA", "DECIMOQUINTA", "DÉCIMO SEXTA",
  "DECIMO SEXTA", "DECIMOSEXTA", "DÉCIMO SÉPTIMA", "DÉCIMO SEPTIMA", "DECIMO SEPTIMA",
  "DECIMOSÉPTIMA", "DÉCIMO OCTAVA", "DECIMO OCTAVA", "DECIMOCTAVA", "DÉCIMO NOVENA",
  "DECIMO NOVENA", "DECIMONOVENA", "VIGÉSIMA", "VIGESIMA",
];
const ORDINAL_DECENAS = ["VIGÉSIMO", "VIGESIMO", "TRIGÉSIMO", "TRIGESIMO"];
const ORDINAL_UNIDADES = [
  "PRIMERA", "SEGUNDA", "TERCERA", "CUARTA", "QUINTA", "SEXTA", "SÉPTIMA", "SEPTIMA",
  "OCTAVA", "NOVENA",
];

const esc = (s) =>
  String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

const UNDERLINE_START = "[[[U]]]";
const UNDERLINE_END = "[[[/U]]]";

const renderText = (s) => esc(s)
  .replaceAll(UNDERLINE_START, '<span class="ct-fill">')
  .replaceAll(UNDERLINE_END, "</span>");

function esOrdinal(texto) {
  if (ORDINALES.includes(texto)) return true;
  const partes = texto.split(/\s+/);
  return partes.length === 2 && ORDINAL_DECENAS.includes(partes[0]) && ORDINAL_UNIDADES.includes(partes[1]);
}

function lineaTipo(linea) {
  const t = linea.trim();
  if (!t) return { tipo: "vacio" };
  const upper = t.toUpperCase();
  if (upper.startsWith("INVENTARIO")) return { tipo: "inventario", texto: t };
  if (SECCIONES.includes(upper)) return { tipo: "seccion", texto: t };
  // Estipulación: "PRIMERA. -", "QUINTA BIS. -"
  const mEstip = t.match(/^([A-ZÁÉÍÓÚÑ]+(?:\s+[A-ZÁÉÍÓÚÑ]+)?(?:\s+BIS)?)\.\s*-?\s*(.*)$/);
  if (mEstip && esOrdinal(mEstip[1].replace(/\s+BIS$/, ""))) {
    return { tipo: "estipulacion", label: mEstip[1] + ". -", resto: mEstip[2] };
  }
  // Recital romano: "I.-", "II.-", "III.-"
  const mRom = t.match(/^([IVX]+)\.\s*-?\s*(.*)$/);
  if (mRom) return { tipo: "recital", label: mRom[1] + ".-", resto: mRom[2] };
  return { tipo: "parrafo", texto: t };
}

function esFirmaAntigua(linea) {
  const t = linea.trim();
  if (!t) return false;
  return /^En prueba de aceptación y conformidad/i.test(t)
    || /^FDO\.:\s+FDO\.:$/i.test(t)
    || /^PARTE ARRENDADORA\s+PARTE ARRENDATARIA$/i.test(t);
}

function firmaImg(signatureSrc, className, alt = "Firma arrendador") {
  if (!signatureSrc) return "";
  return `<img class="${className}" src="${esc(signatureSrc)}" alt="${esc(alt)}" onerror="this.style.display='none'" />`;
}

function bloqueFirmas(arrendador, soloArrendador) {
  // Documentos que solo se entregan al inquilino (reserva): firma únicamente el arrendador
  if (soloArrendador) {
    return `
    <p class="ct-disclaimer">Y para que así conste, se firma el presente documento en el lugar y fecha arriba indicados.</p>
    <div class="ct-signatures">
      <div class="ct-sign ct-sign-landlord"><div class="ct-sign-line ct-sign-line-hidden"></div><p>FDO.: ${esc(arrendador)}</p><p class="ct-sign-role">PARTE ARRENDADORA</p></div>
    </div>`;
  }
  return `
    <p class="ct-disclaimer">En prueba de aceptación y conformidad, y para que así conste, las partes suscriben el presente documento, por duplicado ejemplar y a un solo efecto, en el lugar y fecha arriba indicados.</p>
    <div class="ct-signatures">
      <div class="ct-sign ct-sign-landlord"><div class="ct-sign-line ct-sign-line-hidden"></div><p>FDO.: ${esc(arrendador)}</p><p class="ct-sign-role">PARTE ARRENDADORA</p></div>
      <div class="ct-sign"><div class="ct-sign-line ct-sign-line-hidden"></div><p>FDO.:</p><p class="ct-sign-role">PARTE ARRENDATARIA</p></div>
    </div>`;
}

export function contratoToHtml(texto, { arrendador = "", footerSignatureSrc = "", soloArrendador = false } = {}) {
  const lineas = (texto || "").split("\n");
  let html = firmaImg(footerSignatureSrc, "ct-page-signature", "Visto bueno arrendador");
  let tituloBuffer = [];
  let tituloHecho = false;
  let firmasHechas = false;

  for (let i = 0; i < lineas.length; i++) {
    if (esFirmaAntigua(lineas[i])) continue;

    const info = lineaTipo(lineas[i]);

    // Título: primeras líneas no vacías antes de la primera sección
    if (!tituloHecho && info.tipo !== "seccion" && info.tipo !== "estipulacion" && info.tipo !== "recital") {
      if (info.tipo === "vacio") {
        if (tituloBuffer.length) {
          html += `<h1 class="ct-title">${tituloBuffer.map(renderText).join("<br/>")}</h1>`;
          tituloBuffer = [];
          tituloHecho = true;
        }
        continue;
      }
      // ¿parece parte del título? (mayúsculas, sin punto final largo) en las primeras ~3 líneas
      if (tituloBuffer.length < 3 && info.texto === info.texto.toUpperCase() && i < 6) {
        tituloBuffer.push(info.texto);
        continue;
      }
    }
    if (tituloBuffer.length && !tituloHecho) {
      html += `<h1 class="ct-title">${tituloBuffer.map(renderText).join("<br/>")}</h1>`;
      tituloBuffer = [];
      tituloHecho = true;
    }

    switch (info.tipo) {
      case "vacio":
        break;
      case "seccion":
        html += `<h2 class="ct-section">${renderText(info.texto)}</h2>`;
        break;
      case "inventario":
        if (!firmasHechas) {
          html += bloqueFirmas(arrendador, soloArrendador);
          firmasHechas = true;
        }
        html += `<h2 class="ct-section ct-inventory-title">${renderText(info.texto)}</h2>`;
        break;
      case "estipulacion":
        html += `<p class="ct-clause"><strong class="ct-clause-num">${esc(info.label)}</strong> ${renderText(info.resto)}</p>`;
        break;
      case "recital":
        html += `<p class="ct-clause"><strong class="ct-clause-num">${esc(info.label)}</strong> ${renderText(info.resto)}</p>`;
        break;
      default: {
        // Línea de fecha "En Barakaldo, a ..." → centrada
        if (/^En\s.+,\s*a\s+/i.test(info.texto)) {
          html += `<p class="ct-date">${renderText(info.texto)}</p>`;
        } else {
          html += `<p class="ct-p">${renderText(info.texto)}</p>`;
        }
      }
    }
  }

  if (!firmasHechas) html += bloqueFirmas(arrendador, soloArrendador);

  return html;
}

export const CONTRATO_CSS = `
  @page {
    size: A4;
    margin: 2.2cm 2cm 2.2cm 2.6cm;
    @bottom-center {
      content: "Hoja " counter(page) " de " counter(pages);
      font-family: 'Times New Roman', Georgia, serif;
      font-size: 9pt;
      color: #555;
      vertical-align: middle;
    }
  }
  * { box-sizing: border-box; }
  body { font-family: 'Times New Roman', Georgia, serif; color: #1a1a1a; font-size: 12pt; line-height: 1.55; margin: 0; }
  .ct-title { text-align: center; text-transform: uppercase; font-size: 15pt; font-weight: 700; line-height: 1.3; margin: 0 0 4px; letter-spacing: .02em; }
  .ct-date { text-align: center; font-weight: 600; margin: 6px 0 22px; }
  .ct-section { text-align: center; text-transform: uppercase; font-size: 13pt; font-weight: 700; letter-spacing: .12em; margin: 26px 0 12px; }
  .ct-inventory-title { page-break-before: always; break-before: page; margin-top: 0; }
  .ct-clause { text-align: justify; margin: 0 0 12px; hyphens: auto; }
  .ct-clause-num { text-transform: uppercase; }
  .ct-fill { text-decoration: underline; text-underline-offset: 2px; }
  .ct-p { text-align: justify; margin: 0 0 11px; hyphens: auto; }
  .ct-disclaimer { text-align: justify; margin: 36px 0 0; }
  .ct-signatures { display: flex; justify-content: space-between; align-items: flex-start; gap: 40px; margin-top: 30px; page-break-inside: avoid; }
  .ct-sign { width: 45%; text-align: center; }
  .ct-sign-img { display: block; width: 150px; max-height: 58px; object-fit: contain; margin: 0 auto 4px; }
  .ct-sign-line { border-top: 1px solid #1a1a1a; margin-bottom: 6px; height: 1px; }
  .ct-sign-line-hidden { border-top-color: transparent; }
  .ct-sign p { margin: 2px 0; font-weight: 600; }
  .ct-sign-role { font-weight: 700 !important; text-transform: uppercase; font-size: 10pt; }
  .ct-clause, .ct-p { page-break-inside: avoid; }
  .ct-page-signature { position: fixed; left: -1.85cm; top: 50%; width: 125px; max-height: 45px; object-fit: contain; transform: translateY(-50%) rotate(-90deg); transform-origin: center; z-index: 10; opacity: .9; }
`;
